import * as yup from 'yup';
import { fieldRequired, maxLength } from '../../../../../constants';

export const validation2284 = yup.object().shape({
  reportingProgram: yup.string().required(fieldRequired),
  orgAddress: yup.string().nullable().max(255, `${maxLength} 255`),
  incidentLocation: yup.string().nullable().max(255, `${maxLength} 255`),
  incidentAddress: yup.string().nullable().max(255, `${maxLength} 255`),
  otherDescription: yup.string().nullable().max(255, `${maxLength} 255`),
  caseManagerName: yup.string().nullable().max(255, `${maxLength} 255`),
  caseManagerTelephone: yup.string().nullable().max(255, `${maxLength} 255`),
  caseManagerEmail: yup.string().nullable().max(255, `${maxLength} 255`),
  arrestingAgency: yup.string().nullable().max(255, `${maxLength} 255`),
  lawEnforcementAgency: yup.string().nullable().max(255, `${maxLength} 255`),
  newsAgency: yup.string().nullable().max(255, `${maxLength} 255`),
  newsRepNameAndPhone: yup.string().nullable().max(255, `${maxLength} 255`),
  incidentDescription: yup.string().nullable(),
  contactedAgenciesName: yup.string().nullable().max(255, `${maxLength} 255`),
});
